import React from 'react'
import { connect } from 'react-redux'

import { doLogout } from 'tyan/reducers/actions'
import Message from '../public/components/Message'

class Logout extends React.Component {
  componentDidMount() {
    this.props.doLogout()
  }
  render() {
    return <Message text="注销中" />
  }
}

export default connect(null, { doLogout })(Logout)